export const PREVIEW_ATTRIBUTE = "data-librarium-preview";
export const PREVIEW_SELECTOR = `[${PREVIEW_ATTRIBUTE}]`;
export const PREVIEW_OBSERVER_DEBOUNCE_MS = 32;
